module.exports = __webpack_public_path__ + "img/SKMJ_protect4.ed78bba4.jpg";